module.exports = __webpack_public_path__ + "static/media/sixsense-location-map.4e78304a.png";